import { useNavigation } from 'modules/core/hooks/useNavigation'

import TrashBinDataTable from 'modules/documents/components/TrashBin/TrashBinDataTable'
import { SPACES } from 'modules/documents/lib/constants'

const EmployeeTrashPage = () => {
  const { navigation } = useNavigation()

  return (
    <TrashBinDataTable
      space={SPACES.EMPLOYEE_MY_DOCUMENTS}
      getItemRoute={(documentId) =>
        navigation.files.trash.employee.documentId.fullPath({ document_id: documentId })
      }
      parentRoute={navigation.files.trash.employee.fullPath()}
    />
  )
}

export default EmployeeTrashPage
